import React from 'react'
import { Box, Stack, Image, Flex, Text, Link, Heading } from '@chakra-ui/react'
import { useDispatch, useSelector } from 'react-redux'
import { setInfoBoxOpen } from '../../../redux/actions/map.actions'
import { baseUrl } from '../../../config'
import CustomDrawer from '../../Drawer'

export default function InfoBox() {
  const dispatch = useDispatch()
  const isInfoBoxOpen = useSelector((state) => state.mapStates.isInfoBoxOpen)
  const btnRef = React.useRef()

  const onClose = () => {
    dispatch(setInfoBoxOpen(false))
  }
  return (
    <>
      <CustomDrawer
        isOpen={isInfoBoxOpen}
        title="Information"
        size="lg"
        onClose={onClose}
        finalFocusRef={btnRef}
      >
        <Box>
          <Box mb={6} mt={4}>
            <Heading as="h4" size="md" mb={2}>
              User manual
            </Heading>
            <Box mb={2}>
              <Link
                target="_blank"
                rel="noreferrer"
                color={'blue.500'}
                href="https://www.researchgate.net/publication/367362631_Manual_of_the_GeoSES_InSAR_Web_Viewer"
              >
                To access GeoSES InSAR WebViewer Manual and Technical
                Documentation, please click on this link.
              </Link>
            </Box>
          </Box>
          <Heading as="h4" size="md" my={2}>
            Information
          </Heading>
          <Box>
            <Text mb={2} textAlign="justify">
              One of the main objectives of the GeoSES* project to investigate
              dangerous natural and anthropogenic geo-processes and aim hazard
              assessment using space geodetic technologies and concentrating on
              the Hungary-Slovakia-Romania-Ukraine cross-border region. The
              monitoring of such natural hazards and emergency situations (e.g.
              landslides and sinkholes ) are also additional objectives of the
              project. In the framework of the presented project, our study
              utilizes one of the fastest developing space-borne remote sensing
              technology, namely InSAR, which is an outstanding tool to conduct
              large scale ground deformation observation and monitoring.
              According this, we utilized ascending and descending Sentinel-1
              Level-1 SLC acquisitions since 2014 until 2021 over the indicated
              cross-border area, focusing the Transcarpathian Region.
            </Text>
            <Text mb={2} textAlign="justify">
              We also present an automated processing chain of Sentinel-1
              interferometric wide mode acquisitions to generate long-term
              ground deformation time-series. The pre-processing part of the
              workflow includes the migration of the input data from the Alaska
              Satellite Facility (ASF), the integration of precise orbits from
              S1QC, as well as the corresponding radiometric calibration and
              mosaicing of the TOPS mode data, furtheromore the geocoding of the
              geometrical reference. Subsequently all slave acquisition have be
              co-registered to the geometrical reference using iterative
              intensity matching and spectral diversity methods, then subsequent
              deramping has been also performed. To retrieve deformation time
              series from co-registered SLCs stacks, we have implemented
              multi-reference Interferometric Point Target Analysis (IPTA) using
              singe-look and multi-look phases using the GAMMA Software. After
              forming differential interferometric point stacks, we conducted
              the iterative IPTA processing. According this both topographical
              and orbit-related phase component, as well as the atmospheric
              phase, height-dependent atmospheric phase and linear phase term
              supplemented with the deformation phase are modeled and refined
              through iterative steps. To retrieve recent deformations of the
              investigated area, SVD LSQ optimization has been utilized to
              transform the multi-reference stack to single-reference phase
              time-series such could be converted to LOS displacements within
              the processing chain. Involving both ascending and descending LOS
              solutions also supports the evaluation of quasi East-West and
              Up-Down components of the surface deformations. Results are
              interpreted both in regional scale and through local examples of
              the introduced cross-border region as well.
            </Text>
            <Text mb={4} textAlign="justify">
              * Hungary-Slovakia-Romania-Ukraine (HU-SK-RO-UA) ENI Cross-border
              Cooperation Programme (2014-2020) “GeoSES” - Extension of the
              operational "Space Emergency System"
            </Text>
            <Text>
              <Text as={'span'} fontWeight="bold">
                How to cite:
              </Text>{' '}
              Magyar, B. and Horvath, R.: Regional scale monitoring results of
              surface deformation in the Transcarpathian Region, EGU General
              Assembly 2022, Vienna, Austria, 23–27 May 2022, EGU22-9443,{' '}
              <Text
                as="a"
                href="https://doi.org/10.5194/egusphere-egu22-9443"
                target={'_blank'}
              >
                https://doi.org/10.5194/egusphere-egu22-9443
              </Text>
              , 2022.
            </Text>
          </Box>
          <Flex justifyContent={'center'} py={10}>
            <Stack direction="row" spacing={2}>
              <a
                href="https://huskroua-cbc.eu/"
                target="_blank"
                rel="noreferrer"
              >
                <Image
                  height={50}
                  width={'140px'}
                  src={`${baseUrl}/images/huskroua.svg`}
                ></Image>
              </a>
              <a
                href="https://geod.bme.hu/geod/geoses_projekt"
                target="_blank"
                rel="noreferrer"
              >
                <Image
                  height={'50px'}
                  width={'60px'}
                  src={`${baseUrl}/images/geoses.png`}
                ></Image>
              </a>
              <a
                href="https://www.bme.hu/?language=en"
                target="_blank"
                rel="noreferrer"
              >
                <Image
                  height={50}
                  width={'auto'}
                  src={`${baseUrl}/images/BME.png`}
                ></Image>
              </a>
              <a
                href="https://www.sgo-penc.hu/index_eng.php"
                target="_blank"
                rel="noreferrer"
              >
                <Image
                  height={50}
                  width={'auto'}
                  src={`${baseUrl}/images/SGO.svg`}
                ></Image>
              </a>
            </Stack>
          </Flex>
        </Box>
      </CustomDrawer>
    </>
  )
}
